import { css, cx } from '@fable/theme'
import { useStats } from 'app/webview/pages/stats_profile/lib/ctx/stats'
import {
  getRatingResult,
  getRatingsRowCount,
} from 'app/webview/pages/stats_profile/lib/utils'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const RatingsGridBars = () => {
  const stats = useStats((s) => s.stats)
  const theme = useStatsTheme((s) => s.theme)
  const { ratings } = getRatingResult(stats)
  const rowCount = getRatingsRowCount(stats?.ratings?.top?.count || 0)

  return (
    <div
      className={cx(
        css`
          display: grid;
          grid-template-columns: repeat(${ratings.length}, 1fr);
          height: 100%;
          gap: 0 10px;
          position: relative;
          z-index: 1;
        `,
        'stats-ratings-grid-bars'
      )}
    >
      {ratings?.map((r, i) => {
        const progress = Math.round((r.count / rowCount) * 100)

        return (
          <div
            key={i}
            className={css`
              grid-row: 1 / ${rowCount + 1};
              border-radius: 6px;
              position: relative;
              overflow: hidden;
            `}
          >
            <span
              className={css`
                width: 1%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 50%;
                transform: translateX(-50%);
                border-right: 1px dashed ${theme.colors.section.textSecondary};
                opacity: 0.25;
              `}
            />
            <span
              className={css`
                display: block;
                width: 100%;
                height: 100%;
                position: absolute;
                top: 0;
                left: 0;
                z-index: 2;
                background-color: ${theme.colors.section.chart.ghost};
              `}
            />
            <div
              className={css`
                display: block;
                width: 100%;
                height: ${progress}%;
                z-index: 3;
                position: absolute;
                bottom: 0;
                left: 0;
                right: 0;
              `}
            >
              <span
                className={cx(
                  'anim__ratings-bar',
                  'stats-ratings-grid-bar',
                  css`
                    display: block;
                    width: 100%;
                    height: 0%;
                    background-color: ${theme.colors.primary};
                    border-radius: 6px;
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    will-change: height;
                  `
                )}
              />
            </div>
          </div>
        )
      })}
    </div>
  )
}
